import $ from 'jquery'

var scrollHandling = {
    allow: true,
    reallow: function() {
        scrollHandling.allow = true;
    },
    delay: 800, //(milliseconds) adjust to the highest acceptable value
    disallow: false
};

function loadmoreiniciatives() {
    const iniciativesListWrapper = $('.iniciatives__list > .wrapper')
    const iniciativesList = $('.iniciatives__grid')

    var button = $('.iniciatives__list > .wrapper .load-more');
    var curr_page = 2;
    var loading = false;
    

    // console.log('loadmore cat at start: '+ category)
    // console.log('loadmore curr page at start: '+ curr_page)

    $(window).scroll(function(){
        if( !loading && scrollHandling.allow && !scrollHandling.disallow) {
            scrollHandling.allow = false;
            setTimeout(scrollHandling.reallow, scrollHandling.delay);

            var offset = $(button).offset().top - $(window).scrollTop();
            // console.log(offset)
            
            if( 1200 > offset ) {
                loading = true;
                iniciativesListWrapper.addClass('loading');
                const category = $('.js-radio-category.is-active').attr('id');
                const status = $('.js-radio-status.is-active').attr('id');
                const region = $('.js-radio-region.is-active').attr('id');
              
                $.ajax({
                    url : ajax_object.ajax_url,
                    type : 'POST',
                    data : {
                        category,
                        status,
                        region,
                        curr_page,
                        action:'loadmoreinitiatives'
                    },
                    beforeSend : function(xhr){
                      // iniciativesListWrapper.addClass('loading');
                    },
                    success : function( res ){
                        // console.log('loadmore cat: ' + category)
                        var $data = $(res);
                        if ($data.length) {
                            iniciativesList.append($data)
                            iniciativesListWrapper.removeClass('loading');
                            curr_page = curr_page + 1;
                            loading = false; 
                            $data = $data.filter( function() { return this.nodeName == 'LI' } )
                            // console.log($data.length);
                            if($data.length < 9) {
                                scrollHandling.disallow = true;
                            }
                            // console.log('loadmore curr page on loadmore: ' + curr_page)
                        } 
                    },
                    error: function(xhr) {
                        console.log('Error');
                    }
                })
            }
        }
    })
}

function filteriniciatives() {
    const iniciativesListWrapper = $('.iniciatives__list > .wrapper')
    const iniciativesList = $('.iniciatives__grid')
    
    var curr_page = 1;

    const category = $('.js-radio-category.is-active').attr('id');
    const status = $('.js-radio-status.is-active').attr('id');
    const region = $('.js-radio-region.is-active').attr('id');
    
    scrollHandling.disallow = false;

    console.log('filter cat: '+ category)
    console.log('filter curr page: '+ curr_page)
    $.ajax({
        url : ajax_object.ajax_url,
        type : 'POST',
        data : {
            category,
            status,
            region,
            curr_page,
            action:'filterinitiatives'
        },
        beforeSend : function(xhr){
            iniciativesList.empty();
            iniciativesListWrapper.addClass('loading');
        },
        success : function( res ){
            // console.log('filter cat: ' + category)
            var $data = $(res);
            if ($data.length) {
                iniciativesList.html($data)
                iniciativesListWrapper.removeClass('loading');
                if($data.length < 9) {
                    scrollHandling.disallow = true;
                }
            } 
        }
    })
}


function initiniciatives() {

    loadmoreiniciatives()

    $(document).on('submit', '.js-filter-status-selected', function(event) {
        $(this).toggleClass('is-active');
        $('.js-filter-status-dropdown').toggleClass('is-active');
    })
    $(document).on('click', '.js-filter-status-selected', function(event) {
        $('.js-filter-selected').removeClass('is-active')
        $('.js-filter-dropdown').removeClass('is-active')
        $(this).toggleClass('is-active');
        $('.js-filter-status-dropdown').toggleClass('is-active');
    })

    $(document).on('submit', '.js-filter-category-selected', function(event) {
        $(this).toggleClass('is-active');
        $('.js-filter-category-dropdown').toggleClass('is-active');
    })
    $(document).on('click', '.js-filter-category-selected', function(event) {
        $('.js-filter-selected').removeClass('is-active')
        $('.js-filter-dropdown').removeClass('is-active')
        $(this).toggleClass('is-active');
        $('.js-filter-category-dropdown').toggleClass('is-active');
    })

    $(document).on('submit', '.js-filter-region-selected', function(event) {
        $(this).toggleClass('is-active');
        $('.js-filter-region-dropdown').toggleClass('is-active');
    })
    $(document).on('click', '.js-filter-region-selected', function(event) {
        $('.js-filter-selected').removeClass('is-active')
        $('.js-filter-dropdown').removeClass('is-active')
        $(this).toggleClass('is-active');
        $('.js-filter-region-dropdown').toggleClass('is-active');
    })

    $(document).on('click', '.js-radio-status', function(event) {
        $('.js-radio-status').removeClass('is-active')
        $(this).addClass('is-active')
        var btn_text = $(this).data('name')
        $('.js-filter-status-selected').text(btn_text)
        $('.js-filter-status-dropdown').toggleClass('is-active')
        $('.js-filter-status-selected').toggleClass('is-active')
    })
    $(document).on('click', '.js-radio-category', function(event) {
        $('.js-radio-category').removeClass('is-active')
        $(this).addClass('is-active')
        var btn_text = $(this).data('name')
        $('.js-filter-category-selected').text(btn_text)
        $('.js-filter-category-dropdown').toggleClass('is-active')
        $('.js-filter-category-selected').toggleClass('is-active')
    })
    $(document).on('click', '.js-radio-region', function(event) {
        $('.js-radio-region').removeClass('is-active')
        $(this).addClass('is-active')
        var btn_text = $(this).data('name')
        $('.js-filter-region-selected').text(btn_text)
        $('.js-filter-region-dropdown').toggleClass('is-active')
        $('.js-filter-region-selected').toggleClass('is-active')
    })

    $(document).on('click', '.iniciatives__filter .js-filter-button', function(event) {
        event.preventDefault()
        // console.log('kliknuto')
        filteriniciatives() 
        loadmoreiniciatives()
    })
}

initiniciatives()
